import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useEffect, useState } from "react";
import { Button, SelectPicker } from "rsuite";
import {
  messageTypeArr,
  roleTypeArr,
  statusArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreServices } from "../../../core/services/StoreServices";
import { get } from "lodash/fp";

const StoreBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onBulkPublish,
  onBulkDelete,
  onExportStore,
  onBulkAssignStoreGroup,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onBulkPublish?: any;
  onBulkDelete?: any;
  onExportStore?: any;
  onBulkAssignStoreGroup?: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const company = useSelector((state: any) => state.company);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [groupId, setGroupId] = useState<number>(null);
  const [openBulkPublishModal, setOpenBulkPublishModal] = useState(false);
  const [openExportStoreModal, setOpenExportStoreModal] = useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [openGroupAssignModal, setOpenGroupAssignModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const [bulkPublishStatus, setBulkPublishStatus] = useState("");
  const [noSelectionMessage, setNoSelectionMessage] = useState("");

  useEffect(() => {
    storeGroupSearch("", company.id);
  }, [company.id]);

  async function storeGroupSearch(searchGroup?: string, forComp?: number) {
    let compId: number = getCompanyId(forComp);

    if (!compId) {
      setStoreGroupList([]);
      return;
    }
    let params: any = { smart_search: searchGroup };
    if (compId) {
      params.company = compId;
      params.sort_by = "region_id";
      params.sort_order = "asc";
    }
    try {
      const res = await StoreServices.getStoreGroups(params);
      const respData = get("data.data", res);
      setStoreGroupList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function getCompanyId(forComp?: number) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = forComp ? forComp : company.id;
    }
    return compId;
  }

  function bulkPublish(status: string) {
    if (checkedKeys.length === 0) {
      setNoSelectionMessage(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkPublishModal(true);
    setBulkPublishStatus(status);
    let msg = t("CONFIRM_ACTION", {
      action:
        status == statusArr.active
          ? t("PUBLISH").toLowerCase()
          : t("UNPUBLISH").toLowerCase(),
      entity: t("STORE").toLowerCase(),
    });
    setBulkActionMessage(msg);
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: "",
      })
    );
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setNoSelectionMessage(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("STORE").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  function bulkAssignGroup() {
    if (checkedKeys.length === 0) {
      setNoSelectionMessage(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    if (groupId === null) {
      setNoSelectionMessage(
        t("PLEASE_SELECT_FIELD", {
          field: t("STORE").toLowerCase() + " " + t("GROUP").toLowerCase(),
        })
      );
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenGroupAssignModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("ASSIGN") + " " + t("GROUP") + " " + t("TO").toLowerCase(),
        entity: t("STORE"),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("ASSIGN") + " " + t("GROUP"),
      })
    );
  }

  return (
    <div className="store-action col-md-8 customer-action">
      {UtilityServices.hasPermission("publish-store") && (
        <React.Fragment>
          <Button onClick={() => bulkPublish("1")}>{t("PUBLISH")}</Button>
          <Button onClick={() => bulkPublish("0")}>{t("UNPUBLISH")}</Button>
        </React.Fragment>
      )}
      {UtilityServices.hasPermission("delete-store") && (
        <Button onClick={bulkDelete}>{t("DELETE")}</Button>
      )}
      {UtilityServices.hasPermission("export-store") && (
        <Button onClick={() => setOpenExportStoreModal(true)}>
          {t("EXPORT")}
        </Button>
      )}
      {UtilityServices.hasPermission("update-store") && (
        <>
          <Button onClick={bulkAssignGroup}>
            {t("ASSIGN")} {t("GROUP")}
          </Button>
          <Button size="lg">
            <SelectPicker
              placeholder={t("SELECT") + " " + t("STORE") + " " + t("GROUP")}
              data={storeGroupList}
              onSearch={(e: any) => {
                if (e) {
                  //storeGroupSearch(e);
                }
              }}
              valueKey="id"
              labelKey="region_group_name"
              onSelect={(value, item) => {
                setGroupId(value);
              }}
              onClean={(e: any) => {
                setGroupId(null);
              }}
              name="store_group_id"
              value={groupId}
            />
          </Button>
        </>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={noSelectionMessage}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkPublish(bulkPublishStatus);
            setOpenBulkPublishModal(false);
          } else {
            setOpenBulkPublishModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkDelete && onBulkDelete();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openGroupAssignModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkAssignStoreGroup && onBulkAssignStoreGroup(groupId);
            setOpenGroupAssignModal(false);
            setGroupId(null);
          } else {
            setOpenGroupAssignModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openExportStoreModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportStore();
            setOpenExportStoreModal(false);
          } else {
            setOpenExportStoreModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("STORE").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
    </div>
  );
};

export default StoreBulkAction;
